import React from 'react'
import BarNavAdmins from './barnavAdmins/BarNavAdmins'
import { useState, useEffect } from 'react'
import BD from './BD'
import Estadisticas from './Estadisticas'
import Registras from './Registras'
import RamApps from './RamApps'
import Consentimientos from './Consentimientos'
import Sugerencias from './Sugerencias'

function AdminsHome({setBarnavState}) {
const [visibilityBd, setVisibilityBd] = useState(true)
const [visibilityEstadistica, setVisibilityEstadistica] = useState(false)
const [visibilityRegistro, setVisibilityRegistro] = useState(false)  
const [visibilityRamRegister, setVisibilityRamRegister] = useState(false)
const [visibilityPeopleAcceptConditions, setVisibilityPeopleAcceptConditions] = useState(false)
const [visibilityComments, setVisibilityComments] = useState(false)
const apiCentral = "https://apicentral-67bm.onrender.com"


useEffect(() => {
  setBarnavState(false)
},[])


  return (
    <div>
      <React.Fragment>
        <div className='container-true-barnav-admins'>
        <BarNavAdmins setVisibilityComments={setVisibilityComments} setVisibilityPeopleAcceptConditions={setVisibilityPeopleAcceptConditions} setVisibilityBd={setVisibilityBd} setVisibilityEstadistica={setVisibilityEstadistica} setVisibilityRegistro={setVisibilityRegistro} setVisibilityRamRegister={setVisibilityRamRegister} />
        </div>
{visibilityBd && <BD apiCentral={apiCentral} />}
  {visibilityEstadistica && <Estadisticas apiCentral={apiCentral} />}
  {visibilityRegistro && <Registras apiCentral={apiCentral} />}
  {visibilityRamRegister && <RamApps apiCentral={apiCentral} />}
  {visibilityPeopleAcceptConditions && <Consentimientos apiCentral={apiCentral} />}
    {visibilityComments && <Sugerencias apiCentral={apiCentral} />}
      </React.Fragment>



    </div>
  )
}

export default AdminsHome